import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/others/shortcuts";

export default {
  getListOfShortcutList() {
    return Repository.get(`${resource}`)
  },
  createShortcut(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteShortcut(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  getShortCutData(url) {
    return Repository.get(url)
  },
};
